import { KeyboardEvent, MouseEvent, useCallback, useEffect, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"

import { AgGridReact } from "ag-grid-react"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"
import { SYS4030_R01Content } from "./Content_SYS4030_R01"
import { defaultSYS4030_R01Dto, SYS4030_R01Dto } from "./Dto_SYS4030_R01"
import { SYS4030_R01SearchSection } from "./SearchSection_SYS4030_R01"
import { useSYS4030_R01Store } from "./Store_SYS4030_R01"
import { SYS4030_R01Table } from "./Table_SYS4030_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_SYS4030_R01 = () => {
	

	const { 
		SYS4030_R01Filter,
		SYS4030_R01PastFilter,
		SYS4030_R01List,
		insertSYS4030_R01List,
		removeSYS4030_R01List,
		addDeletedSYS4030_R01List,
		allCount,
		initData
	} = useSYS4030_R01Store();
	const { setMessage } = useUiuxStore();

	

	const gridRef = useRef<AgGridReact<SYS4030_R01Dto>>(null);

	// UserContent에서 필요한 핸들러 함수들을 가져옴
	const {
		clickable, setClickable,
		defaultSYS4030_R01Row,
		handleExcelClick,
		handleorgNmChange,
		fetchData,
		initContainerData,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
		buttonDisabled,
	} = SYS4030_R01Content({
		gridRef,
		setMessage,
	});

	useEffect(() => { 
		if (SYS4030_R01List.length === 0) { handleInsertClick({} as MouseEvent<HTMLButtonElement>); }
	}, [SYS4030_R01List, handleInsertClick]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		
		<SYS4030_R01SearchSection 
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				<SYS4030_R01Table 
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					defaultSYS4030_R01Row={defaultSYS4030_R01Row()}
				/>
			</div>
		</div>
		{/* 메시지 표시 컴포넌트 */}
		<Message />
	</div>
}